import { memo, PropsWithChildren } from 'react';

type PanelProps = {
  style?: React.CSSProperties;
  className?: string;
};

export const Panel = memo(
  ({ style, className, children }: PropsWithChildren<PanelProps>) => {
    return (
      <div
        data-carousel-panel
        style={{
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          ...style,
        }}
        className={className}
      >
        {children}
      </div>
    );
  }
);

Panel.displayName = 'Carousel.Panel';
